import React, { useLayoutEffect, useRef, useState } from "react";
import { CompiledLayoutRenderer } from "./CompiledLayoutRenderer.js";
import { displayLayoutScale } from "../../../util/src/layout-compiler/display-scale.js";

/** The same fitting rule is used by native screens and public web displays. */
export default function ResponsiveCompiledLayoutRenderer(
  props: Omit<
    React.ComponentProps<typeof CompiledLayoutRenderer>,
    "scale" | "fillParent"
  >,
) {
  const root = useRef<HTMLDivElement>(null);
  const [viewport, setViewport] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));
  useLayoutEffect(() => {
    const element = root.current;
    if (!element) return;
    const observer = new ResizeObserver(([entry]) => {
      if (!entry) return;
      const { width, height } = entry.contentRect;
      setViewport((previous) =>
        previous.width === width && previous.height === height
          ? previous
          : { width, height },
      );
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={root}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        backgroundColor: props.document.scene.backgroundColor,
      }}
    >
      <CompiledLayoutRenderer
        {...props}
        scale={displayLayoutScale(viewport, props.document.meta.canvas)}
      />
    </div>
  );
}
